import { useIntersectionObserver } from '@siberiacancode/reactuse';
import React from 'react';

import { useAppSelector } from '../../../app/stores/hooks';
import { selectSort, useGetTaskListQuery } from '../../../entities/tasks';
import { getTask } from '../../../entities/tasks/model/lib/data-formatting';
import { rootSettings } from '../../../shared/config';
import { sortTaskFunc } from '../../../shared/lib';
import { TaskInList } from '../../../shared/model/tasks/types';
import { Message } from '../../../shared/ui/Message';
import { TaskList } from '../../../shared/ui/TaskList';

const texts = {
  start: {
    text: 'Введите поисковый запрос',
    title: 'Поиск',
  },
  empty: {
    text: 'По данному поисковому запросу результаты не найдены',
    title: 'Поиск',
  },
};

type SearchStatuses = keyof typeof texts;

type Props = {
  value: string;
};

export const TaskSearch: React.FC<Props> = ({ value }) => {
  const [sortField, sortDir] = useAppSelector(selectSort);
  const [offset, setOffset] = React.useState<number>(0);

  const result = useGetTaskListQuery();

  const { ref } = useIntersectionObserver<HTMLDivElement>({
    threshold: 1,
    onChange: (entry) => {
      if (entry.isIntersecting) {
        setOffset((prev) => prev + rootSettings.perPage);
      }
    },
  });

  const data = React.useMemo((): TaskInList[] | SearchStatuses => {
    if (!value) {
      setOffset(rootSettings.perPage);
      return 'start';
    }

    const filteredTasks: TaskInList[] = [];
    result.data?.forEach((task) => {
      if (task.task_name.includes(value)) {
        filteredTasks.push(getTask(task));
      }
    });

    if (filteredTasks.length <= rootSettings.perPage) {
      setOffset(rootSettings.perPage);
    }

    if (!filteredTasks.length) {
      return 'empty';
    }

    return filteredTasks.sort(sortTaskFunc(sortField, sortDir)).slice(0, offset);
  }, [result.data, offset, sortField, sortDir, value]);

  return Array.isArray(data) ? (
    <>
      <TaskList values={data} />
      <div ref={ref} />
    </>
  ) : (
    <Message {...texts[data]} />
  );
};
